'use strict';

angular.module('amexReconciliationApp')
  .service('LockStatusService', function () {
    var self = this;

    self.isLocked = function (transaction) {
      return _.get(transaction, 'lockStatus', 'FULLY_LOCKED') === 'FULLY_LOCKED';
    };

    self.isPartiallyLocked = function (transaction) {
      return _.get(transaction, 'lockStatus', 'FULLY_LOCKED') === 'PARTIALLY_LOCKED';
    };
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/services/LockStatusService.js
// module id = 641
// module chunks = 0